// extracted by mini-css-extract-plugin
export var dropdown = "universalFooterMenu-module--dropdown--897af";
export var label = "universalFooterMenu-module--label--0bfa9";
export var menuList = "universalFooterMenu-module--menuList--a6c60";
export var menuListItem = "universalFooterMenu-module--menuListItem--8c6d6";
export var menuTitle = "universalFooterMenu-module--menuTitle--2224b";